module.exports = __webpack_public_path__ + "img/cartilla.d8e791ea.svg";